export default function Gallery() {
  const images = [
    { src: '/premium-project-block.png', size: 'large' },
    { src: '/premium-project-v2.png', size: 'small' },
    { src: '/premium-project-v3.png', size: 'small' },
    { src: '/premium-project-v6.png', size: 'large' },
    { src: '/premium-project-v4.png', size: 'small' },
    { src: '/premium-project-v5.png', size: 'small' },
  ];

  return (
    <div className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">Proje Galerisi</h2>
          <div className="flex items-center justify-center gap-3">
            <span className="inline-flex items-center gap-2 bg-red-600 text-white text-sm font-bold px-4 py-1.5 rounded-full shadow">
              <i className="ri-image-line"></i>
              {images.length} Proje
            </span>
            <a
              href="/gallery"
              className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 text-sm font-semibold px-4 py-1.5 rounded-full border border-teal-200 hover:bg-teal-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-gallery-line"></i>
              Tüm Galeriyi Gör
            </a>
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          {images.map((image, index) => (
            <a
              key={index}
              href="/gallery"
              className={`relative group overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer ${
                image.size === 'large' ? 'md:row-span-1' : ''
              }`}
            >
              <div className="w-full h-80">
                <img
                  src={image.src}
                  alt="KARE YAPI"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-6 left-6">
                  <span 
                    className="text-white text-xl font-semibold"
                    style={{ fontFamily: 'Raleway, sans-serif' }}
                  >
                    KARE YAPI
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center">
          <a
            href="/gallery"
            className="inline-block bg-red-600 text-white px-10 py-3 rounded-lg font-semibold hover:bg-red-700 transition-colors cursor-pointer whitespace-nowrap"
            style={{ fontFamily: 'Raleway, sans-serif' }}
          >
            TÜMÜNÜ LİSTELE
          </a>
        </div>
      </div>
    </div>
  );
}